module.exports = __webpack_public_path__ + "static/media/return_macbook_mockup.e45303d4.svg";